import { HeaderContext } from "@tanstack/react-table";
import { ReactNode } from "react";
import { Button } from "./button";
import { ArrowUpDown } from "lucide-react";

export const generateSortableHeader = <T,>(headerTitle: ReactNode) => {
  return ({ column }: HeaderContext<T, unknown>) => (
    <>
      <Button
        variant="ghost"
        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        {headerTitle}
        <ArrowUpDown className="ml-2 h-4 w-4" />
      </Button>
    </>
  );
};
